export const setTranslationValues = (translation = '', values = {}) => {
  // for (const key in values) {
  //   translation = translation.replaceAll(`{{${key}}}`, `${values[key]}`);
  // }
  Object.keys(values).forEach((key) => {
    translation = translation.replaceAll(`{{${key}}}`, `${values[key]}`);
  });
  return translation;
};
